export interface GetReportRequest {
	sessionId: number;
	userId: number;
}
